import React from 'react';
import 'twin.macro';
import { CJEvent } from 'types/event';
import { ClassroomsOrg } from 'types/school';
import { BOLabels } from 'types/user';
import { AtelierCard } from './AtelierCard';
import { AteliersStyleWrapper } from 'containers/CahierJournal/Print/componentsSexy/AteliersStyleWrapper';
import { useEleveGroups } from 'queries/eleveGroups/useEleveGroups';
import { useEphemeralEleveGroups } from 'queries/eleveGroups/useEphemeralEleveGroups';
import { format } from '@teetsh/app/src/utils/time/format';
import { useMemo } from 'react';
import { isRotateInSeance } from 'containers/CahierJournal/EventModal/ModalBody/Ateliers/isRotateInSeance';
import { RotateInSeanceTable } from 'containers/CahierJournal/EventModal/ModalBody/Ateliers/RotateInSeanceTable';
import { areAteliersEmpty } from 'containers/CahierJournal/EventModal/ModalBody/Ateliers/areAteliersEmpty';
import tw from 'twin.macro';

interface Props {
  event: CJEvent;
  condensed: boolean;
  boLabels: BOLabels;
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
  onAtelierClick: (id: string) => (event: React.MouseEvent) => void;
  className?: string;
}

export function AtelierEvent(props: Props) {
  const { event, boLabels, onAtelierClick, className } = props;

  const { data: regularGroups = [] } = useEleveGroups();

  const fromDate = format(event.start, 'fr-FR', 'yyyy-MM-dd');
  const toDate = format(event.end, 'fr-FR', 'yyyy-MM-dd');
  const { data: ephemeralGroups = [] } = useEphemeralEleveGroups({
    from: fromDate,
    to: toDate,
  });

  // Pas forcément nécessaire ici le useMemo mais ça mange pas de pain
  const eleveGroups = useMemo(() => {
    const groupMap = new Map();
    regularGroups.forEach(group => groupMap.set(group.id, group));
    ephemeralGroups.forEach(group => groupMap.set(group.id, group));
    return Array.from(groupMap.values());
  }, [regularGroups, ephemeralGroups]);

  const rotateInSeance = isRotateInSeance(event.ateliers);
  const ateliersEmpty = areAteliersEmpty(event.ateliers);
  const shouldDisplayAteliersDetails = !(ateliersEmpty && rotateInSeance);

  return (
    <div className={className} tw="flex flex-col">
      <AteliersStyleWrapper dashedBorder={!ateliersEmpty}>
        {shouldDisplayAteliersDetails &&
          event.ateliers.map(a => {
            const atelierGroups = (eleveGroups || []).filter(g =>
              (a?.groupPivots || [])?.map(gp => gp.id).includes(g.id),
            );
            return (
              <AtelierCard
                key={a.id}
                boLabels={boLabels}
                print={false}
                atelier={a}
                groups={rotateInSeance ? [] : atelierGroups}
                attachments={a.attachments}
                onClick={onAtelierClick(a.id)}
              />
            );
          })}

        {rotateInSeance && (
          <div css={[!ateliersEmpty && tw`p-2`]}>
            <RotateInSeanceTable
              condensed
              ateliers={event.ateliers}
              groups={eleveGroups || []}
              startTime={event.start}
              endTime={event.end}
            />
          </div>
        )}
      </AteliersStyleWrapper>
    </div>
  );
}
